<template>
  <div class="analytic">
    <medsos-mention-reach-component
      v-if="cekChart(1)"
      :key="mention_reach_key"
      :data="mention_reach"
      :stats="mention_reach_stats"
      :is_loading="is_loading"
    />

    <topik-by-source-component
      v-if="cekChart(9)"
      :key="data_topic_source_key"
      :data="data_topic_source"
      :tipe="'medsos'"
      :activeChannel="activeChannel"
      :is_loading="is_topic_source_loading"
    />

    <medsos-tren-mention-sources-component
      v-if="cekChart(2)"
      :key="data_sources_key"
      :data="data_sources"
      :stats="data_sources_stats"
      :activeChannel="activeChannel"
      :is_loading="is_more_one_year ? is_yearly_trend_loading : is_loading"
      style="margin-bottom: 10px !important"
    />

    <div v-if="cekChart(3)" class="mt-4">
      <persentase-tren-sentiment-component
        :key="data_sentiment_key"
        :data="data_sentiment"
        :stats="data_sentiment_stats"
        :is_loading="is_loading"
      />
    </div>

    <tren-by-topik-component
      v-if="cekChart(4)"
      :key="data_mention_per_topik_key"
      :data="data_mention_per_topik"
      :stats="data_mention_per_topik_stats"
      :is_loading="is_more_one_year ? is_yearly_topic_loading : is_loading"
    />

    <div class="mt-4" v-if="added_charts.includes(10) && data_emotion">
      <persentase-tren-emotion-component
        :key="data_emotion_key"
        :data="data_emotion"
        :stats="data_emotion_stats"
        :is_loading="is_loading"
      />
    </div>

    <div class="row mb-1">
      <div class="col-md-6 col-sm-12 col-xs-12 col-lg-6 px-gap">
        <!-- START WIDGET D3 widget_graphWidget-->
        <div
          id="hashtag"
          class="widget-12 card card-default widget-loader-circle shade"
        >
          <div class="card-body" style="min-height: 520px">
            <div class="d-flex align-items-center">
              <div class="">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Hashtag</h4>
                  <p class="small hint-text">Grafik tren hashtag dalam</p>
                </div>
              </div>
              <div class="form-check form-check-inline switch ml-auto m-t-10">
                <input
                  v-model="is_wordcloud_hashtag"
                  type="checkbox"
                  id="pagesSwitchHashtag"
                />
                <label for="pagesSwitchHashtag">Word Cloud</label>
              </div>
              <div class="ml-2">
                <select
                  v-model="current_source"
                  class="rounded form-control-sm form-custom"
                  @change="changeFilterSource"
                >
                  <option value="all">Semua Media</option>
                  <option value="twitter">Twitter</option>
                  <option value="facebook">Facebook</option>
                  <option value="instagram">Instagram</option>
                  <option value="youtube">Youtube</option>
                  <option value="tiktok">Tiktok</option>
                  <option value="forum">Forum</option>
                  <option value="blog">Blog</option>
                  <option value="review">Review Aplikasi</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-sm-12">
                <loader-component v-if="hashtag_dataset == null" />
                <div
                  v-else-if="Object.keys(hashtag_dataset).length === 0"
                  class="alert alert-danger"
                  role="alert"
                  align="center"
                >
                  <strong> Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div v-else class="row">
                  <div
                    v-if="!is_wordcloud_hashtag"
                    class="col-md-12 col-sm-12 col-lg-12"
                  >
                    <bar-chart-component
                      :key="hashtag_key"
                      :dataset="hashtag_dataset"
                      barchart_id="bar-hashtag"
                    />
                  </div>
                  <div
                    v-else
                    class="col-md-12 col-sm-12 col-lg-12"
                    id="wordcloud-hashtag"
                  >
                    <word-cloud-chart-component
                      :key="wordcloud_hashtag_key"
                      :dataset="wordcloud_hashtag_dataset"
                      :id="'wordcloud-hashtag'"
                      :min="10"
                      :max="50"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END WIDGET -->
      </div>
      <div class="col-md-6 col-sm-12 col-xs-12 col-lg-6 px-gap">
        <!-- START WIDGET D3 widget_graphWidget-->
        <div
          id="peak-time"
          class="widget-12 card card-default widget-loader-circle shade"
        >
          <div class="card-body" style="min-height: 520px">
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Peak Time</h4>
                  <p class="small hint-text">Heat Map mention</p>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 col-sm-12">
                <loader-component v-if="heatmap_dataset == null" />
                <div
                  v-else-if="Object.keys(heatmap_dataset).length === 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong> Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <heatmap-chart-component
                  v-else
                  :key="heatmap_key"
                  :dataset="heatmap_dataset"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- END WIDGET -->
      </div>
    </div>

    <div class="row mb-1">
      <div class="col-md-12 col-sm-12 col-xs-12 col-lg-12 px-gap">
        <!-- START WIDGET D3 widget_graphWidget-->
        <div
          id="wordcloud-container-medsos"
          class="widget-12 card card-default widget-loader-circle shade"
        >
          <div class="card-body" style="min-height: 520px">
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12">
                <div class="pull-left m-t-5 m-b-5">
                  <h4 class="m-b-0">Word Cloud</h4>
                  <p class="small hint-text">Word Cloud mention</p>
                </div>
              </div>
              <div class="col-lg-4 col-md-4" align="right">
                <div class="form-check form-check-inline switch m-t-20">
                  <input
                    type="checkbox"
                    id="pagesSwitch"
                    @click="hastagToggle"
                  />
                  <label for="pagesSwitch">Tampilkan Tabel</label>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12" id="wordcloud-mention">
                <loader-component v-if="wordcloud_dataset == null" />
                <div
                  v-else-if="Object.keys(wordcloud_dataset).length === 0"
                  class="alert alert-danger"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong> Mohon maaf, data tidak tersedia! </strong>
                  <br />
                  Tidak dapat menampilkan grafik dengan data kosong.
                </div>
                <div class="row" v-else>
                  <div v-show="isHastag === 'yes'" class="col-md-2" />
                  <table-dynamic-component
                    v-show="isHastag === 'yes'"
                    :data_head="table_wordcloud_head"
                    :data_head_class="data_head_class"
                    :data_body="table_wordcloud_body"
                    table_class="table-stripped"
                    :config="table_wordcloud_conf"
                    :key="wordcloud_table_key"
                    class="col-md-8"
                  />
                  <div v-show="isHastag === 'no'" class="col-lg-12 col-md-12">
                    <div class="d-flex align-items-center">
                      <span>Show</span>
                      <select
                        id="select-word-count"
                        class="rounded mx-1 form-control-sm form-custom"
                        v-model="displayItems"
                        @change="getWordCloud()"
                      >
                        <option value="20">20 Data</option>
                        <option value="50">50 Data</option>
                        <option value="100">100 Data</option>
                        <option value="300">300 Data</option>
                      </select>
                      <span>on Wordcloud</span>
                    </div>
                    <loader-component
                      v-if="is_wordcloud_loading"
                      class="mt-5"
                    />
                    <word-cloud-chart-component
                      v-else
                      :key="wordcloud_key"
                      :dataset="wordcloud_dataset"
                      :id="'wordcloud-mention'"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- END WIDGET -->
      </div>
    </div>

    <div class="overlay-button">
      <button title="Manage Grafik" class="btn btn-success" @click="addChart">
        <i class="pg-icon">chart_add</i>
      </button>
    </div>
    <modal-dynamic-component
      v-if="modal"
      :key="modal_key"
      :modal="modal"
      :data="added_charts"
    />
    <v-tour
      v-if="tour_steps.length > 0"
      name="myTour"
      :steps="tour_steps"
      :options="{ highlight: true }"
    ></v-tour>
  </div>
</template>

<script>
import $ from "jquery";
import word_cloud_chart from "@/views/components/chart/word_cloud_chart.vue";
import heatmap_chart from "@/views/components/chart/heatmap_chart.vue";
import medsos_tren_mention_sources from "@/views/components/analytics/general/medsos_tren_mention_sources.vue";
import table_dynamic from "@/views/components/table_dynamic.vue";
import medsos_mention_reach from "@/views/components/analytics/general/medsos_mention_reach.vue";
import tren_by_topik from "@/views/components/analytics/general/tren_by_topik.vue";
import persentase_tren_sentiment from "@/views/components/analytics/general/persentase_tren_sentiment.vue";
import modal_add_medsos_chart from "@/views/components/analytics/general/modal_add_medsos_chart.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import loader_component from "@/views/components/loader.vue";
import bar_chart_highchart from "@/views/components/chart/bar_chart_highchart.vue";
import persentase_tren_emotion from "@/views/components/analytics/general/persentase_tren_emotion.vue";
import topik_by_source from "@/views/components/analytics/general/topik_by_source.vue";

var modal = {
  title: "Manage Grafik",
  subtitle: "Silahkan pilih grafik yang akan ditambahkan ke halaman analytics.",
  component: modal_add_medsos_chart,
};
var table_wordcloud_head = ["Kata", "Frekuensi"];
var table_wordcloud_conf = {
  language: {
    thousands: ".",
    search: "Cari kata:",
  },
  pageLength: 5,
  lengthMenu: [5, 10, 25, 50, 75, 100],
  aaSorting: [[1, "desc"]],
};

var socmed_line_color = [];
socmed_line_color["twitter"] = "#1da1f2";
socmed_line_color["facebook"] = "#4267b2";
socmed_line_color["instagram"] = "#e1306c";
socmed_line_color["youtube"] = "#dc3545";
socmed_line_color["news"] = "#28a745";
socmed_line_color["forum"] = "#6c757d";
socmed_line_color["blog"] = "#ffc107";
socmed_line_color["linkedin"] = "#006192";
socmed_line_color["review"] = "#3f3f3f";

export default {
  name: "Analytics",
  title: "Analytics | Online Media Monitoring",
  components: {
    "word-cloud-chart-component": word_cloud_chart,
    "heatmap-chart-component": heatmap_chart,
    "medsos-tren-mention-sources-component": medsos_tren_mention_sources,
    "table-dynamic-component": table_dynamic,
    "medsos-mention-reach-component": medsos_mention_reach,
    "persentase-tren-sentiment-component": persentase_tren_sentiment,
    "tren-by-topik-component": tren_by_topik,
    "modal-dynamic-component": modal_dynamic,
    "bar-chart-component": bar_chart_highchart,
    "loader-component": loader_component,
    "persentase-tren-emotion-component": persentase_tren_emotion,
    "topik-by-source-component": topik_by_source,
  },
  data() {
    return {
      tour_steps: [],
      isHastag: "no",
      current_source: "all",
      modal: null,
      displayItems: 300,
      table_wordcloud_head: table_wordcloud_head,
      table_wordcloud_body: null,
      table_wordcloud_conf: table_wordcloud_conf,
      data_head_class: [
        {
          head: "Frekuensi",
          class: "text-center",
        },
      ],
      wordcloud_dataset: null,
      hashtag_dataset: null,
      wordcloud_hashtag_dataset: null,
      heatmap_dataset: null,
      mention_reach: null,
      mention_reach_stats: null,
      data_sentiment: null,
      data_sentiment_stats: null,
      data_sources: null,
      data_sources_stats: null,
      data_mention_per_topik: null,
      data_mention_per_topik_stats: null,
      data_emotion: null,
      data_emotion_stats: null,
      data_topic_source: null,
      heatmap_key: 0,
      wordcloud_key: 10,
      wordcloud_hashtag_key: 15,
      hashtag_key: 20,
      mention_reach_key: 30,
      wordcloud_table_key: 40,
      data_sentiment_key: 50,
      data_sources_key: 60,
      modal_key: 70,
      data_mention_per_topik_key: 80,
      data_emotion_key: 90,
      data_topic_source_key: 100,

      dt_head: [],
      dt_body: [],
      dt_config: {},

      id_project: this.$store.getters.user.id_project,
      added_charts: [],
      api_url: process.env.VUE_APP_API_URL,
      res: {},

      is_loading: true,
      is_yearly_trend_loading: true,
      is_yearly_topic_loading: true,
      is_wordcloud_loading: true,
      is_wordcloud_hashtag: false,
      is_topic_source_loading: true,
      activeChannel: null,
    };
  },
  computed: {
    is_more_one_year() {
      var params = this.$route.query;
      var from_date = new Date(params.from);
      var to_date = new Date(params.to);
      var gap = to_date - from_date;
      var year_gap = gap / (1000 * 60 * 60 * 24 * 360);
      return year_gap > 1;
    },
  },
  methods: {
    getChannel: function() {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.activeChannel = response.data.project_detail.crawler;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeFilterSource: function() {
      this.is_wordcloud_hashtag = false;
      this.getHastag();
    },
    hastagToggle: function() {
      if (this.isHastag == "no") {
        this.isHastag = "yes";
      } else {
        this.isHastag = "no";
      }
    },
    addChart: function() {
      this.modal = modal;
      this.modal_key++;
    },
    getWordCloud: function() {
      let self = this;
      self.is_wordcloud_loading = true;
      var params = this.$route.query;
      params.items = this.displayItems;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        let api =
          process.env.VUE_APP_API_URL +
          "wordcloud/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then(function(response) {
            if (response.status != 204) {
              self.wordcloud_dataset = response.data.wordcloud;
              self.wordcloud_key++;
              self.assembleWordcloudTabel(response.data.wordcloud);
            } else {
              self.wordcloud_dataset = {};
              self.wordcloud_key++;
            }
          })
          .catch(function(err) {
            console.log(err);
          })
          .finally(function() {
            self.is_wordcloud_loading = false;
          });
      }
    },
    getHastag: function() {
      var params = this.$route.query;
      if (this.current_source == "all") {
        if ("source" in params) {
          delete params.source;
        }
      } else {
        params.source = this.current_source;
      }
      params.items = 25;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        let api =
          process.env.VUE_APP_API_URL +
          "hashtags/" +
          this.id_project +
          "?" +
          query;
        this.$http.get(api).then((response) => {
          if (response.status == 200) {
            this.assembleDataHashtag(response.data.hashtags);
            this.assembleWordCloudHashtag(response.data.hashtags);
          } else {
            this.hashtag_dataset = [];
          }
        });
      }
    },
    getYearlyTrendData: function() {
      var params = this.$route.query;
      let self = this;
      self.is_yearly_trend_loading = true;
      self.data_sources = null;
      self.data_sources_stats = null;
      self.data_sources_key++;
      let query;
      if ("sources" in params) {
        delete params.sources;
      }
      if ("from" in params && "to" in params) {
        query = Object.keys(params)
          .map((key) => key + "=" + params[key])
          .join("&");
      }
      let api =
        process.env.VUE_APP_API_URL +
        "dashboard-yearly" +
        "/" +
        this.id_project +
        "?" +
        query;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            self.assembleStatsSources(response.data.stats_socmed);
            self.assembleDataSources(response.data.trend_source);
          } else {
            self.data_sources = {};
            let sources_stats = {
              facebook: 0,
              twitter: 0,
              instagram: 0,
              youtube: 0,
              news: 0,
              forum: 0,
              blog: 0,
              tiktok: 0,
              linkedin: 0,
              review: 0,
            };
            self.assembleStatsSources(sources_stats);
            self.data_sources_key++;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(function() {
          self.is_yearly_trend_loading = false;
        });
    },
    getYearlyTopicData: function() {
      let self = this;
      self.is_yearly_topic_loading = true;
      var params = this.$route.query;
      params.tipe = "medsos";
      if ("items" in params) {
        delete params.items;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (query != "") {
        let api =
          process.env.VUE_APP_API_URL +
          "analytics-yearly/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then(function(response) {
            if (self.added_charts.includes(4)) {
              self.assembleDataMentionPerTopik(response.data.trend_topik);
            }
          })
          .catch(function(err) {
            console.log(err);
          })
          .finally(() => {
            self.is_yearly_topic_loading = false;
            this.data_mention_per_topik_key++;
          });
      }
    },
    getData: function() {
      let self = this;
      self.is_loading = true;
      var params = this.$route.query;
      if ("items" in params) {
        delete params.items;
      }
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      this.mention_reach = null;
      this.mention_reach_stats = null;
      this.mention_reach_key++;
      if (!this.is_more_one_year) {
        this.data_sources = null;
        this.data_sources_stats = null;
        this.data_sources_key++;
      }
      this.data_sentiment = null;
      this.data_sentiment_stats = null;
      this.data_sentiment_key++;
      this.hashtag_dataset = null;
      this.hashtag_key++;
      this.heatmap_dataset = null;
      this.heatmap_key++;
      this.data_emotion = null;
      this.data_emotion_stats++;

      if (query != "") {
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "analytics/" +
          this.id_project +
          "?" +
          query;
        this.$http
          .get(api)
          .then(function(response) {
            if (response.status == 200) {
              self.res = response.data;
              self.mention_reach_stats = {
                total: response.data.stats.total.toString(),
                esmr: response.data.stats.esmr.toString(),
                engagement: response.data.stats.engagement.toString(),
              };
              self.data_sentiment_stats = [
                {
                  name: "Positif",
                  y: response.data.stats.positif,
                  color: $("body").css("--success") + "AA",
                },
                {
                  name: "Netral",
                  y: response.data.stats.netral,
                  color: "#0e6d87AA",
                  visible: false,
                },
                {
                  name: "Negatif",
                  y: response.data.stats.negatif,
                  color: $("body").css("--danger") + "AA",
                },
              ];
              self.data_sentiment_stats["name"] = "Mention";

              if (self.added_charts.includes(1)) {
                self.assembleMentionReach(response.data.trend_mention);
              }

              if (self.added_charts.includes(2) && !self.is_more_one_year) {
                self.assembleStatsSources(response.data.stats);
                self.assembleDataSources(response.data.trend_source);
              }

              if (self.added_charts.includes(3)) {
                self.assembleDataSentiment(response.data.trend_sentiment);
              }

              if (self.added_charts.includes(4)) {
                self.data_mention_per_topik_stats = response.data.bar_topik;
              }
              if (self.added_charts.includes(4) && !self.is_more_one_year) {
                self.assembleDataMentionPerTopik(response.data.trend_topik);
              }

              if ("trend_emo" in response.data) {
                self.data_emotion_stats = [
                  {
                    name: "Netral",
                    y: response.data.stats.no_emotion,
                  },
                  {
                    name: "Senang",
                    y: response.data.stats.joy,
                    color: $("body").css("--success") + "AA",
                  },
                  {
                    name: "Takut",
                    y: response.data.stats.fear,
                    color: $("body").css("--warning") + "AA",
                  },
                  {
                    name: "Sedih",
                    y: response.data.stats.sad,
                    color: $("body").css("--teal") + "AA",
                  },
                  {
                    name: "Marah",
                    y: response.data.stats.anger,
                    color: $("body").css("--danger") + "AA",
                  },
                ];
                self.data_emotion_stats["name"] = "Berita";
                self.assembleDataEmotion(response.data.trend_emo);
              }

              self.assemblePeakTime(response.data.peaktime);
            } else {
              self.mention_reach = {};
              self.mention_reach_stats = {
                total: "0",
                esmr: "0",
                engagement: "0",
              };
              self.mention_reach_key++;

              if (!self.is_more_one_year) {
                self.data_sources = {};
                let sources_stats = {
                  facebook: 0,
                  twitter: 0,
                  instagram: 0,
                  youtube: 0,
                  news: 0,
                  forum: 0,
                  blog: 0,
                  tiktok: 0,
                  linkedin: 0,
                  review: 0,
                };
                self.assembleStatsSources(sources_stats);
                self.data_sources_key++;
              }

              self.data_sentiment = {};
              self.data_sentiment_stats = [];
              self.data_sentiment_stats["positif"] = 0;
              self.data_sentiment_stats["netral"] = 0;
              self.data_sentiment_stats["negatif"] = 0;
              self.data_sentiment_key++;

              self.data_mention_per_topik = {};
              self.data_mention_per_topik_stats = [];

              self.heatmap_dataset = {};
              self.heatmap_key++;
            }
          })
          .catch(function(err) {
            console.log(err);
          })
          .finally(() => {
            self.is_loading = false;
            this.data_mention_per_topik_key++;
          });
      }
    },
    getTopikSource: function() {
      this.is_topic_source_loading = true;
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
      if (query != "") {
        this.data_topic_source = null;
        this.query = query;
        let api =
          process.env.VUE_APP_API_URL +
          "charts/bar/topic-source/" +
          this.id_project +
          "?tipe=medsos&" +
          query;
        this.$http
          .get(api)
          .then((response) => {
            if (response.status == 200) {
              this.data_topic_source = response.data;
            } else {
              this.data_topic_source = {};
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.is_topic_source_loading = false;
          });
      }
    },
    assemblePeakTime: function(dataset) {
      let x_label = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu",
      ];
      let y_label = [];
      let time_string;
      for (var i = 0; i < 24; i++) {
        if (i < 10) {
          time_string = "0" + i + ":00 - 0" + i + ":59";
        } else {
          time_string = i + ":00 - " + i + ":59";
        }
        y_label.push(time_string);
      }
      let data = {
        value: dataset,
        x_label: x_label,
        y_label: y_label,
      };

      this.heatmap_dataset = data;
      this.heatmap_key++;
    },
    assembleWordcloudTabel: function(dataset) {
      let tabel_body = [];
      for (let data in dataset) {
        let row = [];
        row[0] = data;
        row[1] = `<center>${dataset[data]}</center>`;
        tabel_body.push(row);
      }
      this.table_wordcloud_body = tabel_body;
      this.wordcloud_table_key++;
    },
    assembleMentionReach: function(dataset) {
      this.mention_reach = dataset;
      this.mention_reach_key++;
    },
    assembleDataSentiment: function(dataset) {
      let data = {
        x: dataset.date,
        y: [
          {
            name: "Positif",
            data: dataset.positif,
            color: $("body").css("--success"),
          },
          {
            name: "Netral",
            data: dataset.netral,
            color: $("body").css("--info"),
            visible: false,
          },
          {
            name: "Negatif",
            data: dataset.negatif,
            color: $("body").css("--danger"),
          },
        ],
        yName: "Total",
      };
      this.data_sentiment = data;
      this.data_sentiment_key++;
    },
    assembleDataSources: function(dataset) {
      let data_series_trend_sosmed = [];
      for (let v_source in dataset) {
        if (v_source != "date") {
          if (this.activeChannel) {
            if (
              v_source == "twitter" &&
              this.activeChannel.twitter.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Twitter",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "facebook" &&
              this.activeChannel.facebook.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: v_source == "Facebook",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "instagram" &&
              this.activeChannel.instagram.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Instagram",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "youtube" &&
              this.activeChannel.youtube.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Youtube",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "forum" &&
              this.activeChannel.google.forum_status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Forum",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "blog" &&
              this.activeChannel.google.blog_status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Blog",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "linkedin" &&
              this.activeChannel.linkedin.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Linkedin",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "popular tiktok" &&
              this.activeChannel.tiktok.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Tiktok",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            } else if (
              v_source == "review" &&
              "review" in this.activeChannel &&
              this.activeChannel.review.status == 1
            ) {
              data_series_trend_sosmed.push({
                name: "Review Aplikasi",
                data: dataset[v_source],
                color: this.$channel_color[v_source],
              });
            }
          }
        }
      }
      let data = {
        y: data_series_trend_sosmed,
        x: dataset.date,
        yName: "Total",
      };

      this.data_sources = data;
      this.data_sources_key++;
    },
    assembleStatsSources: function(dataset) {
      let sources = [];
      if (this.activeChannel && this.activeChannel.twitter.status == 1) {
        sources.push({
          icon: "bi bi-twitter",
          name: "Twitter",
          count: dataset.twitter.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.facebook.status == 1) {
        sources.push({
          icon: "bi bi-facebook",
          name: "Facebook",
          count: dataset.facebook.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.instagram.status == 1) {
        sources.push({
          icon: "bi bi-instagram",
          name: "Instagram",
          count: dataset.instagram.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.tiktok.status == 1) {
        sources.push({
          icon: "bi bi-tiktok",
          name: "Tiktok",
          count: dataset.tiktok.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.youtube.status == 1) {
        sources.push({
          icon: "bi bi-youtube",
          name: "Youtube",
          count: dataset.youtube.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.linkedin.status == 1) {
        sources.push({
          icon: "bi bi-linkedin",
          name: "Linkedin",
          count: dataset.linkedin.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.google.forum_status == 1) {
        sources.push({
          icon: "bi bi-chat-dots-fill",
          name: "Forum",
          count: dataset.forum.toString(),
        });
      }
      if (this.activeChannel && this.activeChannel.google.blog_status == 1) {
        sources.push({
          icon: "bi bi-rss",
          name: "Blog",
          count: dataset.blog.toString(),
        });
      }
      if (
        this.activeChannel &&
        "review" in this.activeChannel &&
        this.activeChannel.review.status == 1
      ) {
        sources.push({
          icon: "bi bi-phone",
          name: "Review Aplikasi",
          count: dataset.review ? dataset.review.toString() : "0",
        });
      }
      this.data_sources_stats = sources;
    },
    assembleDataMentionPerTopik: function(dataset) {
      let chart_data = [];
      for (let row in dataset) {
        if (row != "date") {
          chart_data.push({
            name: row,
            data: dataset[row],
          });
        }
      }
      let data = {
        x: dataset.date,
        y: chart_data,
        yName: "Total",
      };

      this.data_mention_per_topik = data;
    },
    assembleDataHashtag: function(dataset) {
      let data = [];
      for (let index in dataset) {
        data.push([dataset[index]._id, dataset[index].count]);
      }

      this.hashtag_dataset = data;
      this.hashtag_key++;
    },
    assembleWordCloudHashtag: function(dataset) {
      let wordcloud = {};
      for (var i = 0; i < dataset.length; i++) {
        var obj = dataset[i];
        var key = obj._id;
        var value = obj.count;
        wordcloud[key] = value;
      }
      this.wordcloud_hashtag_dataset = wordcloud;
    },
    assembleDataEmotion: function(dataset) {
      let data = {
        x: dataset.date,
        y: [
          {
            name: "Netral",
            data: dataset.no_emotion,
          },
          {
            name: "Senang",
            data: dataset.joy,
            color: $("body").css("--success") + "AA",
          },
          {
            name: "Takut",
            data: dataset.fear,
            color: $("body").css("--warning") + "AA",
          },
          {
            name: "Sedih",
            data: dataset.sad,
            color: $("body").css("--teal") + "AA",
          },
          {
            name: "Marah",
            data: dataset.anger,
            color: $("body").css("--danger") + "AA",
          },
        ],
        yName: "Total",
      };
      this.data_emotion = data;
      this.data_emotion_key++;
    },
    initChartAnalytic: function() {
      let self = this;
      let api = this.api_url + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            this.added_charts = response.data.project_detail.charts
              ? response.data.project_detail.charts
              : [];
          }
          this.getChannel();
          this.getWordCloud();
          this.getHastag();
          if (self.is_more_one_year) {
            self.getYearlyTopicData();
            self.getYearlyTrendData();
          }
          this.getData();
          this.getTopikSource();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cekChart: function(id) {
      return this.added_charts.includes(id);
    },
  },
  watch: {
    $route() {
      let self = this;
      var params = this.$route.query;
      let query = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");

      if (this.query != query && query != "") {
        if (self.is_more_one_year) {
          self.getYearlyTopicData();
          self.getYearlyTrendData();
        }
        this.getData();
        this.getTopikSource();
        this.getWordCloud();
        this.getHastag();
      }
    },
  },
  created: function() {
    this.initChartAnalytic();
  },
  mounted: function() {
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $("body").offset().top,
      },
      1000
    );
    let v_step = [];
    v_step[0] = {
      target: "#page-header-validasi",
      header: {
        title: "Filter Validasi",
      },
      content: `Digunakan untuk memfilter data berdasarkan status validasi`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[1] = {
      target: "#page-header-select",
      header: {
        title: "Filter Topik",
      },
      content: `Digunakan untuk memfilter data berdasarkan topik`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[2] = {
      target: "#reportrange",
      header: {
        title: "Filter Periode",
      },
      content: `Digunakan untuk memfilter data berdasarkan periode waktu`,
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[3] = {
      target: ".card-body",
      header: {
        title: "Berpindah Tab",
      },
      content:
        "Anda dapat berpindah tab dengan melakukan klik pada media konvensional atau media sosial.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[4] = {
      target: "#mention-reach",
      header: {
        title: "Mention dan Reach",
      },
      content:
        "Menampilkan jumlah mention, jumlah reach, jumlah engagement, dan grafiknya pada media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[5] = {
      target: "#topik-by-source",
      header: {
        title: "Tren Topik Berdasarkan Source",
      },
      content:
        "Menampilkan grafik tren topik berdasarkan sumber dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[6] = {
      target: "#sources",
      header: {
        title: "Sources",
      },
      content:
        "Menampilkan sumber-sumber media sosial dengan jumlah mention untuk setiap sumbernya dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[7] = {
      target: "#tren-sources",
      header: {
        title: "Tren Mention",
      },
      content:
        "Menampilkan grafik tren mention dari setiap sumber pada media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[8] = {
      target: "#grafik-sentimen",
      header: {
        title: "Tren Sentimen",
      },
      content:
        "Menampilkan grafik dan persentase sentimen dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[9] = {
      target: "#daftar-topik",
      header: {
        title: "Daftar Topik",
      },
      content:
        "Menampilkan daftar topik dengan jumlah per sentimen dan total data dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[10] = {
      target: "#tren-topik",
      header: {
        title: "Tren Topik",
      },
      content:
        "Menampilkan grafik data tren berdasarkan topik dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[11] = {
      target: "#emotion",
      header: {
        title: "Emotion",
      },
      content:
        "Menampilkan persentase dan grafik tren emotion dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[12] = {
      target: "#hashtag",
      header: {
        title: "Hashtag",
      },
      content:
        "Menampilkan grafik dari jumlah hashtag untuk setiap mention dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[13] = {
      target: "#peak-time",
      header: {
        title: "Peak Time",
      },
      content:
        "Menampilkan grafik jumlah mention untuk setiap jam dan hari tertentu dari media sosial dalam range waktu sesuai dengan filter tanggal.",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };
    v_step[14] = {
      target: "#wordcloud-container",
      header: {
        title: "Worcloud",
      },
      content:
        "Menampilkan kata kata yang terdapat pada mention dari media sosial dalam range waktu sesuai dengan filter tanggal. Kata yang ukurannya dicetak lebih besar merupakan kata yang memiliki jumlah penggunaan yang lebih banyak",
      params: {
        placement: "top",
        enableScrolling: false,
      },
    };

    this.tour_steps = v_step;
  },
};
</script>

<style>
.overlay-button {
  position: fixed;
  bottom: 45px;
  right: 30px;
  z-index: 9;
}
.overlay-button button {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  font-size: 30px;
  font-weight: bolder;
}
.nav-tabs-simple > li > a:after {
  background-color: #0f8ff9 !important;
}
</style>
